import { MeDto } from '@/src/features/api/authentication/me';

export interface AuthState {
  initialized: boolean;
  user: MeDto | undefined;
  lang: string;
}

export const getDefaultAuthState = (): AuthState => {
  return {
    initialized: false,
    user: undefined,
    lang: localStorage.getItem('lang') ?? 'en',
  };
};
